import type {
  CSSProperties,
  MouseEventHandler,
  ReactNode,
  RefObject,
} from 'react';
import { createContext, useContext } from 'react';

export type OnboardingHighlightName =
  | 'ComposeTeamAverageScore'
  | 'ManagerProfileGallery'
  | 'ManagerProfileGalleryCard'
  | 'MyCardsCommonMarket'
  | 'BuyCommonCard'
  | 'FixtureSelectorContainer'
  | 'PlayProEmptyState'
  | 'DailyClaimButton'
  | 'ComposeTeamRemainingPoints'
  | 'ComposeTeamBenchCardFooter'
  | 'ComposeTeamAdvancedView'
  | 'CollectionPreviewCard'
  | 'CollectionPreviewPicture'
  | 'CollectionPreviewName'
  | 'CollectionPreviewCollectionBonusLabel'
  | 'CollectionPreviewCollectionBonusProgressBar'
  | 'CollectionPreviewStatsCards'
  | 'CollectionPreviewStatsRank'
  | 'CollectionPreviewStatsScore'
  | 'CollectionNavigationSwitch'
  | 'DropCardCta'
  | 'MarketInfoIcon'
  | 'AsideEnergyBalance'
  | 'Missions'
  | 'QuickPlay'
  | 'SeriesBoardReplayButton';

export type OnboardingHighlightConfig = {
  circle?: boolean;
  padding?: number;
  borderRadius?: CSSProperties['borderRadius'];
  border?: boolean;
  filter?: CSSProperties['filter'];
  onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
};
type MeasureHighlightCallback = () => DOMRect | null;

export type Highlight = {
  name: OnboardingHighlightName;
  measureCallback: MeasureHighlightCallback;
  config?: OnboardingHighlightConfig;
  children: ReactNode;
  refToScroll?: RefObject<HTMLElement | null>;
};
type OnboardingHighlightContext = {
  registerHighlight: ({
    name,
    measureCallback,
    config,
    children,
  }: Highlight) => void;
  highlights: Highlight[];
  activeHighlights: OnboardingHighlightName[];
  setActiveHighlights: (highlights: OnboardingHighlightName[]) => void;
};

export const onboardigHighlightContext =
  createContext<OnboardingHighlightContext | null>(null);

export const useOnboardingHighLightContext = () =>
  useContext(onboardigHighlightContext)!;
